/* eslint-disable no-unused-vars */
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMobileScanPaymentDialog } from '../../Selectors'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { setMobileScanPaymentDialog } from '../../ActionCreators'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'

export const VNMobileScanPaymentDialog = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const dialogData = useSelector((state) => getMobileScanPaymentDialog(state))
  const tenderName = dialogData?.get('displayName')

  // capitalizes the first letter of every word
  const capitalizeFirstLetter = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      .join(' ')
  }

  if (dialogData?.get('open')) {
    return (
      <ConfirmModalV2
        onButtonOneClick={() => {
          history.push({
            pathname: '/tender-selection',
            state: {
              tenderAmountInCents: dialogData.get('tenderAmountInCents'),
              previousPaymentType: dialogData.get('scanTender'),
              fromSplit: true,
            },
          })
          dispatch(setMobileScanPaymentDialog(false))
        }}
        onButtonTwoClick={() => {
          dispatch(setMobileScanPaymentDialog(false))
        }}
        headerText={`Scan Another ${capitalizeFirstLetter(tenderName)}?`}
        subtext={`Scan ${tenderName} successful. How would you like to pay the remaining balance?`}
        isKiosk={false}
        buttonOneText={'OTHER TENDER'}
        buttonTwoText={`${tenderName?.toUpperCase()}`}
      />
    )
  }
}
